const colors = {
  // OBSOLETE
  dark1: '#0E1F28',
  light1: '#FAFBF8',
  lightgrey: '#E8E8E8',
  darkgrey: '#BEBEBE',
  grey: '#757575',
  // OBSOLETE

  amaranth: '#E53C4C',
  black: '#121212',
  blackAlpha: '#0000008A',
  blackAlpha2: '#0000005A',
  boulder: '#777777',
  brownMineShaft: '#313131',
  cabaret: '#D94D61',
  conifer: '#88D54F',
  ebonyClay: '#202F38',
  ebonyClay2: '#222A3E',
  firefly: '#0E1F28',
  fruitSalad: '#469B56',
  fruitSalad2: '#42954A',
  gray: '#8D8D8D',
  jaggedIce: '#B8E6D6',
  jungleGreen: '#24A676',
  lightningYellow: '#FEBA12',
  malachite: '#2BE35C',
  bayOfMany: '#2E3191',
  malibu: '#87BBFD',
  mandy: '#E6616A',
  mandy2: '#E9616A',
  terracotta: '#E67461',
  mercury: '#EAEAEA',
  milanoRed: '#C52100',
  mineShaft: '#252525',
  nileBlue: '#172B4D',
  onahau: '#C4F0FF',
  orient: '#005B8C',
  osloGray: '#898B8D',
  persimmon: '#FF5D52',
  pink: '#FDBDC9',
  carouselPink: '#FBE6E8',
  pomegranate: '#F44336',
  red: '#DF0101',
  scarlet: '#FF3100',
  springWood: '#FAFBF8',
  stormGray: '#73747A',
  white: '#FFFFFF',
  lightGrey1: '#EEEEEE',
  limeGreen: '#32CD32',
  portage: '#808DEC',
  purpleHeart: '#801AD8',
  spray: '#70EBE5',
  rimini: '#5567e6',
  riminiLight: '#c2cafc',
  tangerine: '#F28500',
  //rgb(37, 37, 47);
  //rgb(230, 97, 106)
};

const defaultPalette = {
  type: 'light',
  contrastThreshold: 3,
  tonalOffset: 0.2,
  success: { main: '#469B56', light: '#24A676', dark: '#42954A', contrastText: '#FAFBF8' },
  error: { main: '#E53C4C', light: '#FF5D52', dark: '#DF0101', contrastText: '#FAFBF8' },
  info: { main: '#5567E6', light: '#87bbfd', dark: '#2E3191', contrastText: '#FAFBF8' },
  warning: { main: '#FFAB00', light: '#FEBA12', dark: '#F2A405', contrastText: '#FAFBF8' },
  background: {
    default: '#FAFBF8',
    lightGrey: '#d8dce2',
    white: '#FFFFFF',
  },
  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161',
  },
};

const pink = { main: '#E6616A', light: '#E67461', dark: '#D94D61', contrastText: '#FAFBF8' };
const black = { main: '#252525', light: '#313131', dark: '#121212', contrastText: '#FAFBF8' };

const feelThemePalette = {
  ...defaultPalette,
  primary: pink,
  secondary: black,
};

const dealThemePalette = {
  ...defaultPalette,
  primary: black,
  secondary: pink,
};

// AI Studio (YouDeal Studio AI 2) palette — visual language of
// docs/TRAINING/mockups/studio-ai-usability-demo.html. Composed from the
// shared `colors` map where the value already exists there; Studio-only values are
// defined here so they stay auditable/themeable like every other palette.
const aiStudioPalette = {
  coral: colors.mandy, // #E6616A
  coralHover: colors.cabaret, // #D94D61
  coralPressed: '#C44850',
  coralTint: '#FDECEE',
  ink: colors.mineShaft, // #252525
  muted: '#5F5E5A',
  muted2: colors.stormGray, // #73747A
  muted3: colors.osloGray, // #898B8D
  paper: '#FBFBFC',
  card: colors.white,
  white: colors.white,
  border: colors.lightgrey, // #E8E8E8
  border2: '#DFE2EA',
  border3: '#D7DAE0',
  grayBg: '#F1EFEA',
  blue: '#5B6CB5',
  blueBg: '#ECEEFC',
  infoInk: '#3D4EC0',
  teal: '#2E9E8F',
  tealBg: '#E4F4F2',
  tealBorder: '#BFE5E0',
  green: '#4C9A5A',
  greenBg: '#E7F3E9',
  amber: '#B07A00',
  amberBg: '#FFF3D6',
  // "Bundle" already had one, real, independently-duplicated identity across 3
  // files (bundles/BundleItems.js, customers/CustomerBundleItems.js,
  // purchases/TypeChip.js all hardcoded the same #26a69a) — tokenizing that
  // instead of inventing a new hue.
  bundle: '#26A69A',
  bundleBg: '#E1F4F1',
  terracotta: colors.terracotta, // #E67461
  rust: '#B5662E',
  intensityBg: '#FDEDE8',
  warnBg: '#FCEAEA',
  warnFg: '#A32D2D',
  shadow: '0 1px 4px rgba(0, 0, 0, 0.05)',
  hoverShadow: '0 3px 12px rgba(230, 97, 106, 0.12)',
  hoverShadowLg: '0 4px 14px rgba(230, 97, 106, 0.14)',
  whiteOverlay: 'rgba(255, 255, 255, 0.55)',
  modalOverlay: 'rgba(20, 22, 30, 0.45)',
  avatars: ['#185FA5', '#5B4BDB', '#0F6E56', '#854F0B', '#993C1D', '#C44850'],
};

const feelMobilePalette = {
  light: {
    backgroundColor: '#fff',
    main: '#E6626A',
    accent: '#252525',
    text: '#000',
    lightText: '#fff',
  },
  dark: {},
};

const dealMobilePalette = {
  light: {
    backgroundColor: '#fff',
    main: '#252525',
    accent: '#E6626A',
    text: '#000',
    lightText: '#fff',
    accentText: '#252525',
    disabledColor: '#808080',
  },
  dark: {},
};

const trainMobilePalette = {
  light: {
    backgroundColor: '#fff',
    main: '#469B56',
    accent: '#252525',
    text: '#000',
    lightText: '#fff',
    accentText: '#252525',
    warmup: '#E53C4C',
    cooldown: '#5567E6',
    defaultGrey: '#707070',
  },
  dark: {},
};

// Status-stripe vocabulary — the left-edge marker used across YouDeal list/card
// pages (memberships, invoices, workouts, challenges, ...) to read entity state
// at a glance without reading the copy. Reuses aiStudioPalette's existing tones
// rather than introducing new hex values, so it stays one source of truth.
const statusPalette = {
  active: aiStudioPalette.green,
  attention: aiStudioPalette.amber,
  critical: aiStudioPalette.warnFg,
  draft: aiStudioPalette.muted2,
  archived: aiStudioPalette.muted3,
};

// Role-identity colors — one hue per platform/provider role, reused everywhere a
// role is shown as a tag (admin user list, provider Personnel, archived Personnel).
// admin/owner/director already matched aiStudioPalette exactly (re-hardcoded
// locally in modules/admin/users/index.js before this); manager/collaborator are
// new, dedicated role-only hues — kept out of statusPalette since a role is a
// category, not a lifecycle state.
const roleColors = {
  admin: { fg: aiStudioPalette.coral, bg: aiStudioPalette.coralTint },
  owner: { fg: aiStudioPalette.blue, bg: aiStudioPalette.blueBg },
  director: { fg: aiStudioPalette.teal, bg: aiStudioPalette.tealBg },
  manager: { fg: '#E8A33D', bg: '#FDF1DE' },
  collaborator: { fg: '#8E6FB5', bg: '#F2EDFA' },
  customer: { fg: aiStudioPalette.muted2, bg: aiStudioPalette.grayBg },
};

export {
  aiStudioPalette,
  colors,
  dealMobilePalette,
  dealThemePalette,
  defaultPalette,
  feelMobilePalette,
  feelThemePalette,
  roleColors,
  statusPalette,
  trainMobilePalette,
};
